module.exports = __webpack_public_path__ + "static/media/howItWorks2.11feeeec.png";